const BILLING_TYPE_LABELS = {
  CREDIT_CARD: 'Cartão de crédito',
  PIX: 'PIX',
  BOLETO: 'Boleto',
}

const CARD_BRAND_LABELS = {
  VISA: 'Visa',
  MASTERCARD: 'Mastercard',
  ELO: 'Elo',
  AMEX: 'American Express',
  HIPERCARD: 'Hipercard',
  DINERS: 'Diners',
  DISCOVER: 'Discover',
  CABAL: 'Cabal',
  BANESCARD: 'Banescard',
  CREDZ: 'Credz',
  SOROCRED: 'Sorocred',
  CREDSYSTEM: 'Credsystem',
  JCB: 'JCB',
}

export function billingTypeLabel(billingType) {
  const key = String(billingType || '').toUpperCase()
  return BILLING_TYPE_LABELS[key] || null
}

export function cardBrandLabel(brand) {
  const key = String(brand || '').toUpperCase()
  return CARD_BRAND_LABELS[key] || brand || null
}

export function formatPaymentMethodLabel(paymentMethod) {
  const { billingType, cardBrand, cardLast4 } = paymentMethod || {}
  const type = String(billingType || '').toUpperCase()
  if (type === 'CREDIT_CARD') {
    const brand = cardBrandLabel(cardBrand) || 'Cartão'
    if (cardLast4) return `${brand} •••• ${cardLast4}`
    return 'Cartão de crédito'
  }
  if (type === 'PIX') return 'PIX'
  if (type === 'BOLETO') return 'Boleto'
  return billingTypeLabel(billingType) || '—'
}

export function formatMaskedCardNumber(cardLast4) {
  const digits = String(cardLast4 || '').replace(/\D/g, '').slice(-4)
  if (digits.length !== 4) return null
  return `•••• •••• •••• ${digits}`
}

export function getPaymentMethodDisplay(paymentMethod, { cancelled = false } = {}) {
  const type = String(paymentMethod?.billingType || '').toUpperCase()
  if (type === 'CREDIT_CARD') {
    const brand = cardBrandLabel(paymentMethod?.cardBrand) || 'Cartão'
    const masked = formatMaskedCardNumber(paymentMethod?.cardLast4)
    if (cancelled) {
      return {
        type,
        title: 'Cartão removido',
        subtitle: 'Removido após o cancelamento da renovação.',
        masked: null,
        brand: null,
        securityNote: null,
      }
    }
    return {
      type,
      title: brand,
      subtitle: masked ? 'Cobrança automática neste cartão' : 'Cartão de crédito cadastrado',
      masked,
      brand,
      securityNote: masked
        ? 'Exibimos apenas os 4 últimos dígitos. Número completo e CVV não ficam no Sys[mv].'
        : 'Dados sensíveis do cartão ficam apenas na central de pagamentos.',
    }
  }
  if (type === 'PIX') {
    return {
      type,
      title: 'PIX',
      subtitle: 'Renovação manual — gere um novo PIX no checkout quando necessário.',
      masked: null,
      brand: null,
      securityNote: null,
    }
  }
  if (type === 'BOLETO') {
    return {
      type,
      title: 'Boleto',
      subtitle: null,
      masked: null,
      brand: null,
      securityNote: null,
    }
  }
  return {
    type: null,
    title: billingTypeLabel(type) || '—',
    subtitle: null,
    masked: null,
    brand: null,
    securityNote: null,
  }
}

export function buildPaymentMethodFromPlan(plan) {
  if (!plan) return null
  return {
    billingType: plan.billingType || null,
    cardBrand: plan.cardBrand || null,
    cardLast4: plan.cardLast4 || null,
    canUpdateCard:
      String(plan.billingType || '').toUpperCase() === 'CREDIT_CARD' &&
      Boolean(plan.asaasSubscriptionId) &&
      String(plan.status || '').toUpperCase() === 'ACTIVE' &&
      !plan.cancelledAt,
  }
}
